import { render, staticRenderFns } from "./CreateTraits.vue?vue&type=template&id=456da5ca&scoped=true"
import script from "./CreateTraits.vue?vue&type=script&lang=js"
export * from "./CreateTraits.vue?vue&type=script&lang=js"
import style0 from "./CreateTraits.vue?vue&type=style&index=0&id=456da5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456da5ca",
  null
  
)

export default component.exports